import { FormTextField, FormTextFieldProps } from "@bvhi/ui-base";
import { useTranslation } from "react-i18next";

interface Props extends Omit<FormTextFieldProps, "name"> {
  name?: string;
}

export const FormTextFieldEMail = ({ name = "email", label, placeholder, fullWidth, ...props }: Props) => {
  const { t } = useTranslation(["common"]);

  return (
    <FormTextField
      fullWidth={fullWidth ?? true}
      label={label ?? t("common:form.text.field.email.label")}
      name={name}
      placeholder={placeholder ?? t("common:form.text.field.email.placeholder")}
      {...props}
    />
  );
};
